import { usePermissionsV2Store } from "@/store/permissionsV2Store";

import { evaluateCan } from "./can";
import type { PermissionContext } from "./types";

export { evaluateCan } from "./can";
export { useCanCreateBillingPortal, useCanReadSubscriptions } from "./billings";
export type { EffectivePermission, MeResponse, PermissionContext } from "./types";
export { usePermissionsV2Store } from "@/store/permissionsV2Store";

export const usePermissionsV2Loaded = (): boolean => usePermissionsV2Store((s) => s.isLoaded);

export const useCan = (resource: string, action: string, ctx?: PermissionContext): boolean =>
  usePermissionsV2Store((s) =>
    s.isLoaded ? evaluateCan(s.permissions, resource, action, ctx) : false
  );
